import React, { PureComponent } from 'react';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './aboutCookiesPage.scss';

class AboutCookiesPage extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = `https://consent.cookiebot.com/3114ac13-afae-460b-9a32-08a8c1fcf451/cd.js`;
    script.async = true;
    document.getElementById('cookie-declaration').appendChild(script);
  }

  render() {
    return (
      <div
        className={`${styles.aboutCookiesPage} ${styleHelper.contentContainer}`}
      >
        <h2
          className={`${styleHelper.titleLgPrimary} ${styleHelper._title} ${styles.title}`}
        >
          Användning av cookies
        </h2>
        <div
          id="cookie-declaration"
          className={`${styles.cookieDeclaration}`}
        ></div>
      </div>
    );
  }
}

export default AboutCookiesPage;
